"use client";

import { useCart } from "@/lib/cart-store";
import { ShoppingBag } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export function FloatingCartButton() {
  const { items, setOpen, totalItems, totalPrice } = useCart();
  const count = totalItems();

  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 20 }}
          transition={{ type: "spring", stiffness: 260, damping: 22 }}
          onClick={() => setOpen(true)}
          className="fixed bottom-6 right-6 z-40 flex items-center gap-3 pl-3 pr-5 py-3 rounded-full bg-gradient-gold text-white shadow-gold-lg hover:scale-105 transition-transform group"
          aria-label="Voir le panier"
        >
          <span className="relative grid place-items-center w-10 h-10 rounded-full bg-white/20">
            <ShoppingBag className="w-5 h-5" />
            <span className="absolute -top-1 -right-1 grid place-items-center min-w-5 h-5 px-1 rounded-full bg-white text-earth-deep text-[11px] font-bold shadow">
              {count}
            </span>
          </span>
          <div className="text-left leading-none">
            <div className="text-[10px] uppercase tracking-wider text-white/80">
              Panier
            </div>
            <div className="font-display text-sm font-bold">
              {totalPrice().toLocaleString("fr-FR")} FCFA
            </div>
          </div>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
